let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hXws9")).then(() => parcelRequire('bCmcA'));